/* GR SPECIAL ORDERS (Claude 2026-09-27) · /pages/special-orders: the slip is the live preview of the request.
   Typing writes straight onto the slip (the hint and the words crossfade once). Picking "Ship to" inks the country and runs
   the gold dot house -> door once, then it rests landed; a country already chosen at load is drawn landed.
   WhatsApp and email links carry what was typed. On submit a copy stays in this tab (sessionStorage) so the sent / error
   re-render (Shopify posts and reloads the page) can show the visitor's own slip. */
(function () {
  'use strict';
  var root = document.querySelector('[data-gso-page]');
  if (!root) return;
  var KEY = 'gso-req', WA = 'https://wa.me/96181353426?text=', MAIL = 'mailto:customerservice@gouttesrares.com';
  var T = {};
  try { T = JSON.parse(root.querySelector('.gso-i18n').textContent); } catch (e) {}
  var box = root.querySelector('[data-gso-state]');
  var state = box ? box.getAttribute('data-gso-state') : 'form';
  function $(s) { return root.querySelector(s); }
  function each(s, fn) { var l = root.querySelectorAll(s); for (var i = 0; i < l.length; i++) fn(l[i]); }
  function clean(s) { return String(s || '').replace(/\s+/g, ' ').trim(); }
  function save(v) { try { sessionStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} }
  function read() { try { return JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) { return null; } }
  function drop() { try { sessionStorage.removeItem(KEY); } catch (e) {} }
  function put(slip, k, text) {
    var f = slip && slip.querySelector('[data-f="' + k + '"]');
    if (!f || f.children.length < 2) return;
    var h = f.children[0], v = f.children[1];
    if (text) v.textContent = text.length > 160 ? text.slice(0, 158) + '…' : text;
    h.classList.toggle('is-on', !text);
    v.classList.toggle('is-on', !!text);
    if (k === 'b' && text) cut(v, v.textContent);
  }
  /* I4-1: the bottle keeps its page-side alignment when it is too long for the slip; the ellipsis is built here, because
     -webkit-line-clamp drops or misplaces it (Chromium, WebKit) when the text runs against the page direction */
  function cut(v, full) {
    v.textContent = full;
    if (v.scrollHeight <= v.clientHeight + 1) return;
    var lo = 0, hi = full.length, m, s;
    while (lo < hi) { m = (lo + hi + 1) >> 1; v.textContent = full.slice(0, m).replace(/[\s,.;:\u060C]+$/, '') + '\u2026'; if (v.scrollHeight > v.clientHeight + 1) hi = m - 1; else lo = m; }
    s = full.slice(0, lo);
    if (/\S/.test(full.charAt(lo)) && /\s\S+$/.test(s)) s = s.replace(/\s+\S+$/, '');
    v.textContent = s.replace(/[\s,.;:\u060C]+$/, '') + '\u2026';
  }
  /* a label ending in a full-width colon (ja/zh) takes no space before the value */
  function line(label, value) { label = label || ''; return label + (/[：]$/.test(label) ? '' : ' ') + value; }
  function links(v) {
    var m = T.hello || '';
    if (v && v.b) m += '\n' + line(T.look, v.b);
    if (v && v.to) m += '\n' + line(T.ship, v.to);
    var w = WA + encodeURIComponent(m), e = MAIL + '?subject=' + encodeURIComponent(T.subject || '') + '&body=' + encodeURIComponent(m);
    each('[data-gso-wa]', function (a) { a.href = w; });
    each('[data-gso-mail]', function (a) { a.href = e; });
  }
  /* a return from Shopify carries #SpecialOrderForm (the form's action): the browser's fragment step clears focus a few ms
     after this runs (the form is not focusable), so focus again once the page has loaded if nothing else took it */
  function hold(el) {
    if (!el) return;
    el.focus({ preventScroll: true });
    window.addEventListener('load', function () { requestAnimationFrame(function () {
      var a = document.activeElement; if (!a || a === document.body || a === document.documentElement) el.focus({ preventScroll: true });
    }); }, { once: true });
  }
  function first(n) {
    if (/^(ko|zh)/i.test(document.documentElement.lang || '')) return n;
    var q = n.split(/\s+/), nm = q[0];
    if (q[1] && /^(\u0639\u0628\u062f|\u0623\u0628\u0648|\u0627\u0628\u0648|\u0623\u0645|\u0627\u0645|abd|abdul|abdel|abdal|abu|abou|umm)$/i.test(nm)) nm += ' ' + q[1];
    return nm;
  }
  function land(slip, go) {
    if (!slip) return;
    slip.classList.remove('is-go');
    if (go) { void slip.offsetWidth; slip.classList.add('is-go'); }
    slip.classList.add('is-landed');
  }

  if (state === 'form' || state === 'error') {
    var form = box.closest('form');
    var f = { b: $('#gso-b'), to: $('#gso-to'), oc: $('#gso-oc'), n: $('#gso-n'), e: $('#gso-e'), p: $('#gso-p') };
    var fields = $('.gso-form__fields');
    var slip = $('.gso-form__preview .gso-slip'), raf = 0;
    var btn = $('[data-gso-submit]'), lab = $('[data-gso-label]'), label0 = lab ? lab.textContent : '', timer = 0;
    /* the country list comes in the store's order; sort it for the visitor's language ("Choose" stays first, "Another country" last) */
    try {
      var C = new Intl.Collator(document.documentElement.lang || undefined), keep = f.to.value;
      var opts = [].slice.call(f.to.options).filter(function (o) { return o.value && !o.hasAttribute('data-gso-other'); });
      var oth = f.to.querySelector('[data-gso-other]');
      var R = /^ja/.test(document.documentElement.lang) ? { KR: 'かんこく', UM: 'がっしゅうこくりょうゆうしょうりとう', EH: 'にしさはら', GQ: 'せきどうぎにあ', TW: 'たいわん', CF: 'ちゅうおうあふりか', MO: 'まかお', HK: 'ほんこん', CN: 'ちゅうごく', TL: 'ひがしてぃもーる', ZA: 'みなみあふりか', SS: 'みなみすーだん', JP: 'にほん', GF: 'ふつりょうぎあな' } : {};
      var key = function (o) { return R[o.getAttribute('data-iso')] || o.text; };
      opts.sort(function (a, b) { return C.compare(key(a), key(b)); }).forEach(function (o) { f.to.insertBefore(o, oth); });
      f.to.value = keep;
    } catch (e) {}
    var isOther = function () { var o = f.to.options[f.to.selectedIndex]; return !!(o && o.hasAttribute('data-gso-other')); };
    var country = function () { if (isOther() && f.oc && clean(f.oc.value)) return clean(f.oc.value); return f.to.value ? clean(f.to.options[f.to.selectedIndex].text) : ''; };
    var iso = function () { var o = f.to.options[f.to.selectedIndex]; return (o && (o.getAttribute('data-iso') || (o.hasAttribute('data-gso-other') ? 'other' : ''))) || ''; };
    var val = function () { return { b: clean(f.b.value), to: country(), iso: iso(), oc: f.oc && isOther() ? clean(f.oc.value) : '', n: clean(f.n.value), e: clean(f.e.value), p: clean(f.p.value) }; };
    /* the fields that must be filled, in order: "which country" only when "Another country" is chosen */
    var need = function () { return isOther() && f.oc ? [f.b, f.to, f.oc, f.n, f.e] : [f.b, f.to, f.n, f.e]; };
    var other = function () { var on = isOther(); if (fields) fields.classList.toggle('is-other', on); if (f.oc) { f.oc.required = on; if (!on) mark(f.oc, false); } };
    var ok = function (el) { var x = clean(el.value); return el === f.e ? /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(x) : !!x; };
    var mark = function (el, bad) {
      var w = el.closest('.gso-field');
      if (w) w.classList.toggle('is-bad', bad);
      el.setAttribute('aria-invalid', bad ? 'true' : 'false');
      if (bad) el.setAttribute('aria-describedby', el.id + '-x'); else el.removeAttribute('aria-describedby');
    };
    var sync = function () { raf = 0; var v = val(); put(slip, 'b', v.b); put(slip, 'to', v.to); put(slip, 'n', v.n); links(v); };
    var kick = function (e) {
      if (!raf) raf = requestAnimationFrame(sync);
      var t = e && e.target;
      if (t && t.nodeType === 1 && t.getAttribute('aria-invalid') === 'true' && ok(t)) mark(t, false);
    };
    form.addEventListener('input', kick);
    form.addEventListener('change', kick);
    f.to.addEventListener('change', function () {
      other();
      if (f.to.value) land(slip, true); else if (slip) slip.classList.remove('is-go', 'is-landed');
    });

    if (state === 'error') {
      var o = read();
      if (o) {
        if (!f.b.value) f.b.value = o.b || '';
        if (!f.n.value) f.n.value = o.n || '';
        if (!f.e.value) f.e.value = o.e || '';
        if (!f.p.value) f.p.value = o.p || '';
        if (f.oc && !f.oc.value) f.oc.value = o.oc || '';
        if (o.iso) for (var i = 0; i < f.to.options.length; i++) {
          var op = f.to.options[i];
          if (op.getAttribute('data-iso') === o.iso || (o.iso === 'other' && op.hasAttribute('data-gso-other'))) { f.to.selectedIndex = i; break; }
        }
      }
      var errBox = $('.gso-err'), keys = ((errBox && errBox.getAttribute('data-gso-err')) || '').split(',');
      var byKey = { body: f.b, email: f.e, name: f.n };
      for (var k = 0; k < keys.length; k++) if (byKey[keys[k]]) mark(byKey[keys[k]], true);
      other();
      need().forEach(function (el) { if (!ok(el)) mark(el, true); });
      hold(errBox);
    }
    other();
    if (f.to.value) land(slip, false);

    var tok = function () { var t = form.elements['h-captcha-response']; return (t && t.value) || ''; };
    var reset = function () {
      clearTimeout(timer);
      if (!btn) return;
      btn.classList.remove('is-sending'); btn.removeAttribute('aria-busy');
      if (lab) lab.textContent = label0;
    };
    form.noValidate = true;
    /* capture phase + stopImmediatePropagation: Shopify's hCaptcha binder adds its own submit listener to this form
       (preventDefault, then execute() and HTMLFormElement.prototype.submit); preventDefault alone does not stop it,
       so an invalid or repeated submit would still be posted. */
    form.addEventListener('submit', function (e) {
      var stop = function () { e.preventDefault(); e.stopImmediatePropagation(); };
      if (btn && btn.classList.contains('is-sending')) { stop(); return; }
      var first = null;
      need().forEach(function (el) { var good = ok(el); mark(el, !good); if (!good && !first) first = el; });
      if (first) {
        stop(); first.focus({ preventScroll: true });
        var fw = first.closest('.gso-field') || first, rm = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
        try { fw.scrollIntoView({ block: 'nearest', behavior: rm ? 'instant' : 'smooth' }); } catch (x) { fw.scrollIntoView({ block: 'nearest' }); }
        return;
      }
      save(val());
      if (btn) {
        btn.classList.add('is-sending'); btn.setAttribute('aria-busy', 'true');
        if (lab && T.sending) lab.textContent = T.sending;
        var tok0 = tok();
        /* a closed hCaptcha challenge: give the button back; never once a fresh token says the post has gone out (a slow network) */
        timer = setTimeout(function () { var t1 = tok(); if (t1 && t1 !== tok0) return; reset(); }, 8000);
      }
      /* not bound yet (Send was the first thing touched): Shopify's document listener would swallow this submit */
      var cap = window.Shopify && window.Shopify.captcha;
      if (!form.hasAttribute('data-hcaptcha-bound') && cap && typeof cap.protect === 'function') {
        stop();
        form.dispatchEvent(new FocusEvent('focusin', { bubbles: true }));
        cap.protect(form, function () { form.submit(); });
      }
      else if (!form.hasAttribute('data-hcaptcha-bound')) clearTimeout(timer); /* no captcha on the page: the native post is already on its way */
    }, true);
    form.addEventListener('formdata', function (e) {
      if (f.oc && !isOther()) e.formData.delete(f.oc.name);
      if (!btn || btn.classList.contains('is-sending') || !need().every(ok) || !tok()) return;
      clearTimeout(timer); btn.classList.add('is-sending'); btn.setAttribute('aria-busy', 'true'); if (lab && T.sending) lab.textContent = T.sending;
    });
    var resync = function () { other(); if (!f.to.value) { if (slip) slip.classList.remove('is-go', 'is-landed'); } else if (slip && !slip.classList.contains('is-go')) land(slip, false); sync(); };
    window.addEventListener('load', resync, { once: true });
    window.addEventListener('resize', kick);
    window.addEventListener('pageshow', function (e) { if (e.persisted) { var t0 = form.elements['h-captcha-response']; if (t0) t0.value = ''; reset(); resync(); } });
    sync();
  }

  if (state === 'sent') {
    var s = read() || {};
    var sl = $('.gso-sent .gso-slip'), h = $('[data-gso-thanks]');
    var fb = function () { put(sl, 'b', s.b || T.fb_b || ''); }, rb = 0;
    fb();
    put(sl, 'to', s.to || '');
    /* the cut depends on the wrap: again once the fonts are in, and on resize */
    window.addEventListener('load', fb, { once: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fb);
    window.addEventListener('resize', function () { if (!rb) rb = requestAnimationFrame(function () { rb = 0; fb(); }); });
    if (s.n) {
      put(sl, 'n', s.n);
      var nv = sl && sl.querySelector('[data-f="n"] .gso-ink.is-on');
      var over = function () {
        var b = nv.getBoundingClientRect(), r = document.createRange(); r.selectNodeContents(nv);
        var l = r.getClientRects(); for (var i = 0; i < l.length; i++) if (l[i].right > b.right + .01 || l[i].left < b.left - .01) return true;
        return false;
      };
      var fit = function () {
        if (!nv) return;
        nv.style.fontSize = ''; nv.style.overflowWrap = 'normal';
        for (var fs = parseFloat(getComputedStyle(nv).fontSize); fs > 12 && over(); fs -= .5) nv.style.fontSize = (fs - .5) + 'px';
        nv.style.overflowWrap = '';
      };
      var ft; window.addEventListener('resize', function () { clearTimeout(ft); ft = setTimeout(fit, 100); });
      fit(); if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
    }
    if (s.to) land(sl, false);
    if (h && s.n && T.thanks_name) h.textContent = T.thanks_name.replace('[NAME]', first(s.n));
    links(s);
    var d = $('[data-gso-date]');
    if (d) try { d.textContent = new Intl.DateTimeFormat(document.documentElement.lang || 'en', { day: 'numeric', month: 'short', year: 'numeric' }).format(new Date()); } catch (e) {}
    hold(h);
    drop();
  }
})();
